import type { TGetUsersQueryParams } from '../../api/types/users'

export const USER_AGE_MIN = 18

export function usersListQueryArgsFromSearchParams(searchParams: URLSearchParams): TGetUsersQueryParams {
  const queryArgs: TGetUsersQueryParams = {}
  const query = searchParams.get('query')?.trim() ?? ''
  const status = searchParams.get('status')?.trim() ?? ''
  const city = searchParams.get('city')?.trim() ?? ''
  const ageFrom = Number(searchParams.get('age_from'))
  const ageTo = Number(searchParams.get('age_to'))

  if (query) {
    queryArgs.query = query
  }

  if (status && status !== 'all') {
    queryArgs.status = status
  }

  if (city && city !== 'all') {
    queryArgs.city = city
  }

  const hasAgeFrom = Number.isFinite(ageFrom) && ageFrom > 0
  const hasAgeTo = Number.isFinite(ageTo) && ageTo > 0

  if (hasAgeFrom && hasAgeTo) {
    queryArgs.age_from = Math.min(ageFrom, ageTo)
    queryArgs.age_to = Math.max(ageFrom, ageTo)
  } else {
    if (hasAgeFrom) {
      queryArgs.age_from = ageFrom
    }
    if (hasAgeTo) {
      queryArgs.age_from = USER_AGE_MIN
      queryArgs.age_to = ageTo
    }
  }

  return queryArgs
}
